export default {
    name: 'seller',
    serverName: '/api/v1/seller/seller/',
    apiUrl: '/api/v1/seller/seller/'
};
